














































































































































































































































import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import moment from "moment";
import { appModule } from "@/store/modules/app";
import { userModule } from "@/store/modules/user";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import { storePerawat } from "@/store/modules/perawat";
import { Unit, UserLogin } from "@/types";

@Component({ components: { VCDateTimePicker } })
export default class InputRencanaMpp extends Vue {
  @Prop({ default: null }) value!: any;
  @Prop() readonly register!: number;
  @Prop() readonly rm!: string;

  private formError: any = {
    authored_at: null
  };

  unitRanapId = this.stateUser?.unit_id || null;
  unitRanap = this.stateUser?.unit || null;
  authored_at: string | Date = new Date();
  user: UserLogin | null = null;
  unit: Unit | null = null;
  perawatId: number | string | null = null;
  namaPerawat = "";
  category = "rencana";
  id = null;

  mounted() {
    if (!this.listPerawat || this.listPerawat.length === 0) {
      storePerawat.actListPerawatall();
    }
    this.onAspectsDataChange();
  }

  get listPerawat() {
    return storePerawat.listPerawat;
  }

  aspects: any[] = [
    {
      id: "1",
      namaAspek: "Aspek Kondisi Klinis",
      asesmen: [],
      plan: [],
      ket: "",
      asesNote: "",
      planNote: ""
    },
    {
      id: "2",
      namaAspek: "Aspek Psikososial Spiritual",
      asesmen: [],
      plan: [],
      ket: "",
      asesNote: "",
      planNote: ""
    },
    {
      id: "3",
      namaAspek: "Aspek Ekonomi dan Pembiayaan",
      asesmen: [],
      plan: [],
      ket: "",
      asesNote: "",
      planNote: "",
      planInternal: null,
      planEksternal: null,
      planSyarat: []
    },
    {
      id: "4",
      namaAspek: "Aspek Kebutuhan Pemulangan",
      asesmen: [],
      plan: [],
      ket: "",
      asesNote: "",
      planNote: "",
      optKhususSelected: null,
      optKhususNote: ""
    },
    {
      id: "5",
      namaAspek: "Asesmen Utilitas",
      asesmen: [],
      plan: [],
      ket: "",
      asesNote: "",
      planNote: ""
    }
  ];

  aspekKlinis = [
    { id: "1", text: "Paliativ Care", note: "" },
    { id: "2", text: "Kritical Care", note: "" },
    { id: "3", text: "Multiple Organ Failure", note: "" },
    { id: "9", text: "Lainnya", note: "" }
  ];

  aspekPsiko = [
    { id: "1", text: "Hidup sebatangkara", note: "" },
    { id: "2", text: "Pola pikir negatif", note: "" },
    { id: "3", text: "Alkoholis", note: "" },
    { id: "4", text: "Konflik keyakinan", note: "" },
    { id: "9", text: "Lainnya", note: "" }
  ];

  aspekEkonomi = [
    { id: "1", text: "Tidak memiliki asuransi kesehatan", note: "" },
    { id: "2", text: "Tidak bekerja", note: "" },
    { id: "3", text: "Faktor penghasilan", note: "" },
    { id: "4", text: "Kartu asuransi kesehatan tidak aktif", note: "" },
    { id: "5", text: "Jaminan pelayanan tidak dapat diakses", note: "" },
    { id: "6", text: "Tidak ada pembiayaan dari keluarga", note: "" },
    { id: "9", text: "Lainnya", note: "" }
  ];

  aspekKebutuhan = [
    { id: "1", text: "Memerlukan perawatan lanjutan di rumah", note: "" },
    { id: "2", text: "Memerlukan pendampingan ", note: "" },
    { id: "3", text: "Belum mampu mandiri", note: "" },
    { id: "4", text: "Kasus khusus", note: "" },
    { id: "5", text: "Memerlukan pengawasan ketat", note: "" },
    { id: "6", text: "Tidak memiliki tempat berlindung", note: "" },
    { id: "9", text: "Lainnya", note: "" }
  ];

  optKhusus = [
    { id: "1", text: "PIE", note: "" },
    { id: "9", text: "Lainnya", note: "" }
  ];

  aspekUtilitas = [
    { id: "1", text: "Ruang perawatan yang penuh atau deadlock", note: "" },
    {
      id: "2",
      text: "Tidak tersedia tempat rujukan lebih dari 2 x 24 jam",
      note: ""
    },
    { id: "3", text: "Rujukan yang memerlukan konfirmasi lanjut", note: "" },
    { id: "9", text: "Lainnya", note: "" }
  ];

  planKlinis = [
    { id: "1", text: "Fasilitasi Family Class", note: "" },
    { id: "2", text: "Fasilitasi Edukasi", note: "" },
    { id: "3", text: "Fasilitasi konsultasi DPJP dan PPA lain", note: "" },
    { id: "4", text: "Kroscek coding diagnosa", note: "" },
    { id: "5", text: "Fasilitasi Konfrensi klinis", note: "" },
    { id: "6", text: "Monitoring LOS", note: "" },
    { id: "7", text: "Fasilittasi komunikasi antar PPA", note: "" },
    { id: "9", text: "Lainnya", note: "" }
  ];

  planPsiko = [
    { id: "1", text: "Fasilitasi dukungan keluarga", note: "" },
    { id: "2", text: "Pemberian Motivasi", note: "" },
    { id: "3", text: "Kolaborasi TIM Rohaniawan", note: "" },
    { id: "4", text: "Fasilitasi Kehadiran keluarga", note: "" },
    { id: "5", text: "Pendampingan", note: "" },
    { id: "9", text: "Lainnya", note: "" }
  ];

  planEkonomi = [
    {
      id: "1",
      text: "Kolaborasi dan fasilitasi penjaminan internal",
      note: ""
    },
    { id: "2", text: "Fasilitasi dengan penjaminan Eksternal", note: "" },
    {
      id: "3",
      text: "Fasilitasi aktivasi BPJS Kesehatan/BPJS Naker/TASPEN",
      note: ""
    },
    { id: "4", text: "Fasilitasi  persyaratan penjaminan asuransi", note: "" },
    { id: "5", text: "Fasilitasi alternatif jamian", note: "" },
    { id: "6", text: "Aktifitas kendali biaya", note: "" },
    { id: "9", text: "Lainnya", note: "" }
  ];

  optInternal = [
    { id: "1", text: "Admin Ruangan" },
    { id: "2", text: "IPP" },
    { id: "3", text: "Bidang Pelayanan" }
  ];

  optEksternal = [
    { id: "1", text: "BPJS", note: "" },
    { id: "2", text: "ASABRI", note: "" },
    { id: "3", text: "Jasa Raharja", note: "" },
    { id: "4", text: "Jamkesda", note: "" },
    { id: "5", text: "Jamkesos", note: "" },
    { id: "6", text: "Taspen", note: "" },
    { id: "9", text: "Jaminan Kesahatan Lainnya", note: "" }
  ];

  optSyarat = [
    { id: "1", text: "Kronologi" },
    { id: "2", text: "SPM" },
    { id: "3", text: "General Konsen" },
    { id: "4", text: "Pernyataan Jaminan" }
  ];

  planKebutuhan = [
    { id: "1", text: "Koordinasi dengan Fasyankes wilayah setempat", note: "" },
    { id: "2", text: "Fasilitasi keluarga untuk perawatan mandiri", note: "" },
    { id: "3", text: "Fasilitasi Homecare", note: "" },
    {
      id: "4",
      text: "Koordinasi dengan dinas sosial dan dinas terkait",
      note: ""
    },
    {
      id: "5",
      text:
        "Koordinasi dengan DPJP dan PPA tentang Perencanaan pemulangan pasien",
      note: ""
    },
    { id: "9", text: "Lainnya", note: "" }
  ];

  planUtilitas = [
    {
      id: "1",
      text: "Penguraian Penumpukan pasien di PPRI, IGD dan ruang rawat inap",
      note: ""
    },
    {
      id: "2",
      text:
        "Koordinasi dengan DPJP untuk perawatan sementara sebelum mendapatkan tempat rujukan",
      note: ""
    },
    {
      id: "3",
      text: "Koordinasi dengan MPP rumah sakit rujukan bila diperlukan",
      note: ""
    },
    { id: "9", text: "Lainnya", note: "" }
  ];

  getOptions(aspectId, type) {
    if (type === "asesmen") {
      const mapping = {
        "1": this.aspekKlinis,
        "2": this.aspekPsiko,
        "3": this.aspekEkonomi,
        "4": this.aspekKebutuhan,
        "5": this.aspekUtilitas
      };
      return mapping[aspectId] || [];
    } else {
      const mapping = {
        "1": this.planKlinis,
        "2": this.planPsiko,
        "3": this.planEkonomi,
        "4": this.planKebutuhan,
        "5": this.planUtilitas
      };
      return mapping[aspectId] || [];
    }
  }

  get stateUser() {
    return userModule.user;
  }

  close() {
    this.$emit("close");
  }

  async handleFocus(refName: string) {
    await this.$nextTick();
    const element = this.$refs[refName] as any;
    if (element) {
      const target = Array.isArray(element) ? element[0] : element;
      if (target.focus) target.focus();
    }
  }

  handleInteraction(aspect: any, type: string) {
    // 1. Logika Fokus untuk ASESMEN
    if (type === "asesmen") {
      if (aspect.asesmen.includes("9")) {
        this.handleFocus("asesNote" + aspect.id);
      } else {
        aspect.asesNote = ""; // Reset note jika opsi 9 tidak dipilih
      }

      // Khusus Aspek 4: Kasus Khusus
      if (aspect.id === "4") {
        if (aspect.asesmen.includes("4")) {
          this.handleFocus("optKhusus" + aspect.id);
        } else {
          aspect.optKhususSelected = null;
          aspect.optKhususNote = "";
        }
      }
    }

    // 2. Logika Fokus untuk PLAN (Perencanaan)
    if (type === "plan") {
      if (aspect.plan.includes("9")) {
        this.handleFocus("planNote" + aspect.id);
      } else {
        aspect.planNote = "";
      }

      // Khusus Aspek 3: Jaminan
      if (aspect.id === "3") {
        if (aspect.plan.includes("1")) {
          this.handleFocus("planInternal" + aspect.id);
        } else {
          aspect.planInternal = null;
        }

        if (aspect.plan.includes("2")) {
          this.handleFocus("planEksternal" + aspect.id);
        } else {
          aspect.planEksternal = null;
          aspect.planEksternalNote = "";
        }
      }
    }
  }

  @Watch("authored_at")
  onAuthoredAtChange(val: any) {
    if (val) {
      this.formError.authored_at = null;
    }
    this.$emit("input", this.sendData);
  }

  @Watch("aspects", { deep: true })
  onAspectsDataChange() {
    this.$emit("input", this.sendData);
  }

  @Watch("perawatId")
  onPerawatChange(val: any) {
    const found = this.listPerawat.find((p: any) => p.id === val);
    this.namaPerawat = found ? found.nama : "";
    this.$emit("input", this.sendData);
  }

  @Watch("value")
  onValueChanged(newVal: any) {
    if (newVal && newVal.id) {
      this.getData(newVal);
    } else {
      this.resetForm();
    }
  }

  dataRencana() {
    return this.aspects
      .filter(a => a.asesmen.length > 0 || a.plan.length > 0 || a.ket)
      .map(a => {
        const result: any = {
          id: a.id,
          nama_aspek: a.namaAspek,
          asesmen: a.asesmen.map(id => ({
            id,
            text:
              this.getOptions(a.id, "asesmen").find(o => o.id === id)?.text ||
              "",
            ...(id === "9" && a.asesNote ? { note: a.asesNote } : {})
          })),
          plan: a.plan.map(id => ({
            id,
            text:
              this.getOptions(a.id, "plan").find(o => o.id === id)?.text || "",
            ...(id === "9" && a.planNote ? { note: a.planNote } : {})
          }))
          //,keterangan: a.ket || ""
        };

        // Tambahkan properti opsional hanya jika ada
        if (a.id === "4" && a.asesmen.includes("4") && a.optKhususSelected) {
          result.asesKhusus = {
            id: a.optKhususSelected,
            text:
              this.optKhusus.find(o => o.id === a.optKhususSelected)?.text ||
              "",
            ...(a.optKhususSelected === "9" ? { note: a.optKhususNote } : {})
          };
        }

        if (a.id === "3") {
          if (a.plan.includes("1") && a.planInternal)
            result.planInternal = {
              id: a.planInternal,
              text:
                this.optInternal.find(o => o.id === a.planInternal)?.text || ""
            };
          if (a.plan.includes("2") && a.planEksternal) {
            result.planEksternal = {
              id: a.planEksternal,
              text:
                this.optEksternal.find(o => o.id === a.planEksternal)?.text ||
                "",
              ...(a.planEksternal === "9" ? { note: a.planEksternalNote } : {})
            };
          }

          if (a.plan.includes("4") && a.planSyarat) {
            result.planSyarat = a.planSyarat.map((id: string) => {
              const optSyr = this.optSyarat.find((o: any) => o.id === id);
              return { id: id, text: optSyr ? optSyr.text : "" };
            });
          }
        }
        return result;
      });
  }

  get sendData() {
    return {
      id: this.id,
      pasien_rm: this.rm,
      register_id: this.register,
      unit_id: this.stateUser?.unit_id || null,
      user_id: this.stateUser?.id || null,
      unit: {
        id: this.unitRanapId || this.unit?.id,
        nama: this.unitRanap || this.unit?.nama || "-"
      },
      user: {
        id: this.user?.id || this.stateUser?.id,
        nama: this.user?.nama || this.stateUser?.nama || "-"
      },
      authored_at: moment(this.authored_at).format("YYYY-MM-DD HH:mm:ss"),
      category: this.category ? this.category : "rencana",

      content: {
        perawat_id: this.perawatId || null,
        nama_perawat: this.namaPerawat || "",
        rencana: this.dataRencana()
      }
    };
  }

  getData(dataApi: any) {
    if (!dataApi) return;

    // Ambil ID untuk Edit
    this.id = dataApi.id || null;

    this.unit = dataApi.unit || {};
    this.user = dataApi.user || {};

    this.authored_at = dataApi.authored_at
      ? new Date(dataApi.authored_at)
      : new Date();
    this.category = dataApi.category || "rencana";

    // Backward-compat: content lama berbentuk array (tanpa nama perawat),
    // content baru berbentuk objek { nama_perawat, rencana: [...] }.
    const content = dataApi.content || [];
    const rencanaData = Array.isArray(content) ? content : content.rencana || [];
    this.perawatId = Array.isArray(content) ? null : content.perawat_id || null;
    this.namaPerawat = Array.isArray(content) ? "" : content.nama_perawat || "";

    if (Array.isArray(rencanaData)) {
      this.aspects = this.aspects.map(aspect => {
        const aspectId = String(aspect.id);
        const savedData = rencanaData.find(
          (d: any) => String(d.id) === aspectId
        );

        if (!savedData) return aspect;

        // Parsing Asesmen
        const asesList = savedData.asesmen || [];
        const selectedAsesIds = asesList.map((x: any) => String(x.id));
        const asesNote =
          asesList.find((x: any) => String(x.id) === "9")?.note || "";

        // Parsing Plan
        const planList = savedData.plan || [];
        const selectedPlanIds = planList.map((x: any) => String(x.id));
        const planNote =
          planList.find((x: any) => String(x.id) === "9")?.note || "";

        return {
          ...aspect,
          asesmen: selectedAsesIds,
          asesNote: asesNote,
          plan: selectedPlanIds,
          planNote: planNote,
          //,ket: savedData.keterangan || ""
          // Kasus Khusus (Aspek 4)
          optKhususSelected: savedData.asesKhusus
            ? String(savedData.asesKhusus.id)
            : null,
          optKhususNote: savedData.asesKhusus?.note || "",

          // Jaminan (Aspek 3)
          planInternal:
            savedData.planInternal?.id || savedData.planInternal || null,
          planEksternal: savedData.planEksternal?.id || null,
          planEksternalNote: savedData.planEksternal?.note || "",
          planSyarat: (savedData.planSyarat || []).map((x: any) => String(x.id))
        };
      });
    }
  }

  resetForm() {
    this.id = null;
    this.perawatId = null;
    this.namaPerawat = "";
    this.authored_at = new Date();
    this.unit = {
      id: this.stateUser?.unit_id,
      nama: this.stateUser?.unit
    };
    this.user = {
      id: this.stateUser?.id,
      nama: this.stateUser?.nama
    };
    this.unitRanapId = this.stateUser?.unit_id;
    this.unitRanap = this.stateUser?.unit;

    this.aspects.forEach(a => {
      a.asesmen = [];
      a.plan = [];
      a.ket = "";
      a.asesNote = "";
      a.planNote = "";

      // Properti khusus aspek 3 (Ekonomi)
      if (a.id === "3") {
        a.planInternal = null;
        a.planEksternal = null;
        a.planEksternalNote = "";
        a.planSyarat = [];
      }

      // Properti khusus aspek 4 (Kebutuhan Pemulangan)
      if (a.id === "4") {
        a.optKhususSelected = null;
        a.optKhususNote = "";
      }
    });
  }

  datetimeInput() {
    const dtime = new Date();
    if (this.authored_at > dtime) {
      this.$nextTick(() => {
        this.authored_at = null;

        appModule.sendErrorAlert(
          "Tanggal dan jam tidak dapat diinput melebihi <br/>" +
            moment().format("DD-MM-YYYY HH:mm")
        );
      });
    }
  }

  public validasi(): boolean {
    this.formError.authored_at = null;

    if (!this.authored_at) {
      this.formError.authored_at = "Tanggal & Jam Pencatatan wajib diisi";
      return false;
    }
    return true;
  }
}
